export const OverChargeClaimsTypes = {
  GET_ITEMS_FROM_EXCEL_ERROR: 'OVERCHARGE_CLAIMS_TYPE.GET_ITEMS_FROM_EXCEL_ERROR',
  GET_ITEMS_FROM_EXCEL_PROGRESS: 'OVERCHARGE_CLAIMS_TYPE.GET_ITEMS_FROM_EXCEL_PROGRESS',
  GET_ITEMS_FROM_EXCEL_SUCCESS: 'OVERCHARGE_CLAIMS_TYPE.GET_ITEMS_FROM_EXCEL_SUCCESS',
  SET_CLAIM_SEARCH_VIEW_TYPE: 'OVERCHARGE_CLAIMS_TYPE.SET_CLAIM_SEARCH_VIEW_TYPE',
  SET_CLAIM_SEARCH_VIEW_TYPE_INITIAL: 'OVERCHARGE_CLAIMS_TYPE.SET_CLAIM_SEARCH_VIEW_TYPE_INITIAL',
  SET_OVERCHARGE_CLAIM_EDIT_ACTIVE_KEY: 'OVERCHARGE_CLAIMS_TYPE.SET_OVERCHARGE_CLAIM_EDIT_ACTIVE_KEY',
  SET_OVERCHARGE_EDIT_DRAWER: 'OVERCHARGE_CLAIMS_TYPE.SET_OVERCHARGE_EDIT_DRAWER',
  SET_OVERCHARGE_FILTERS: 'OVERCHARGE_CLAIMS_TYPE.SET_OVERCHARGE_FILTERS',
  SET_SELECTED_OVERCHARGE_CLAIMS: 'OVERCHARGE_CLAIMS_TYPE.SET_SELECTED_OVERCHARGE_CLAIMS',
  UPDATE_OVERCHARGE_CLAIM_PROGRESS: 'OVERCHARGE_CLAIMS_TYPE.UPDATE_OVERCHARGE_CLAIM_PROGRESS',
};
